import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import useMediaQuery from '../../hooks/useMediaQuery';
import { TIPO_CORSO } from '../../model/tipoCorso';
import { Button } from 'react-bootstrap';

const AreaPersonaleClassiPage = () => {
  const { getClassiUtenteByToken, loadingStateClassiUtenti } = useClassiUtenti();
  const [classiUtente, setClassiUtente] = useState([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1267px)');

  useEffect(() => {
    fetchClassiUtenteByToken();
  }, []);

  const fetchClassiUtenteByToken = async () => {
    const fetchedClassiUtente = await getClassiUtenteByToken();
    const classiUtente = fetchedClassiUtente.filter(classe => classe.corso.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA);
    setClassiUtente(classiUtente || []);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const handleAccediClasse = (classe) => {
    navigate(`/area-personale/classe`, {state: {classe: classe}});
  };

  if (loadingStateClassiUtenti.isLoadingClassiUtenteByToken) {
    return <CardLoadingPage />;
  }

  return (
    <div className={`card custom-card w-100 shadow`}>
      <div className={`${isMobile ? 'p-3' : 'p-5'}`}>
        <div className='container' style={{minHeight: '700px'}}>
          <div className='d-flex justify-content-between custom-card-header mb-4'>
            <div className='d-flex gap-3'>
              <div className={`custom-icon-container`}>
                <i className={`bi custom-icon bi-mortarboard fs-2`}></i>
              </div>
              <div className='align-self-center'>
                <span className='fs-4 d-block'><i><b>Le Mie Classi</b></i></span>
                <p className={`lead mb-0 ${isMobile ? 'd-none d-md-block' : ''}`}>Gestisci le tue classi e accedi ai materiali didattici</p>
              </div>
            </div>
          </div>
          {isMobile && (
            <p className="lead mb-4">Gestisci le tue classi e accedi ai materiali didattici</p>
          )}
          <div className='container'>
            <div className='row mt-4'>
              {classiUtente?.length === 0 ? (
                <div className='my-5'>
                  <p>Non sei iscritto a nessuna classe al momento.</p>
                </div>
              ) : (
                classiUtente?.map((classe) => (
                  <div key={classe.id_classe_utente} className="col-md-6 col-lg-4 mb-4">
                    <div className="card h-100 shadow-sm">
                      <img src={classe.corso.immagine_corso} className="card-img-top" alt={classe.corso.denominazione} style={{height: '200px', objectFit: 'cover'}} />
                      <div className="card-body">
                        <h5 className="card-title">{classe.denominazione}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">{classe.corso.denominazione}</h6>
                        <p className="card-text">
                          <small className="text-muted">
                            Dal {formatDate(classe.data_inizio)} al {formatDate(classe.data_fine)}
                          </small>
                        </p>
                          <div className={`d-flex ${isMobile ? 'flex-column' : ''} gap-3`}>
                            <Button 
                              variant="primary" 
                              className={`d-flex align-items-center gap-2 ${isMobile ? 'w-100' : ''}`}
                              onClick={() => navigate(`/area-personale/calendario/lezioni`, {
                                state: { classeData: classe }
                              })}
                            >
                              <i className='bi bi-calendar-event'></i>
                              Calendario Lezioni
                            </Button>
                            <Button 
                              variant="primary"
                              className={`d-flex align-items-center gap-2 ${isMobile ? 'w-100' : ''}`}
                              onClick={() => navigate(`/area-personale/calendario/esami`, {
                                state: { classeData: classe }
                              })}
                            >
                              <i className='bi bi-calendar-check'></i>
                              Calendario Esami
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaPersonaleClassiPage;
